import { displayFlashMessage } from "../../util/methods"
import { initializeBarRating } from "./bar_rating"
import { initializeRatingsFormHandler } from "./product_rating_form"
import { initializeRatingsPaginationHandler } from "./product_ratings_pagination"
import { initializeAssetsTabHandlers } from "./product_assets_tab"

$(document).on("turbolinks:load", function () {
  $(".js-back-to-top").on("click", function (e) {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: "smooth" })
  })

  if ($(".js-product-info").length) {
    var $productTabs = $(".js-product-tabs a.nav-link")

    $productTabs.each(function () {
      $(this).on("click", function (e) {
        e.preventDefault()
        let $clickedTab = $(this)
        let $targetElement = $($clickedTab.data("target"))
        let targetURL = $clickedTab.attr("href")
        let $prevActiveTab = $productTabs.filter(".active")
        let $visibleElement = $($prevActiveTab.data("target"))

        // deactivate previous tab and hide its target content
        $prevActiveTab.removeClass("active")
        $visibleElement.hide()

        // activate clicked tab and show target element
        $clickedTab.addClass("active")
        $targetElement.show()

        // retrieve view partial if contents have not been previously loaded
        if (!$targetElement.hasClass("loaded")) {
          loadSectionContent($targetElement, targetURL)
        }
      })
    })
  }
})

export function loadSectionContent(
  $targetElement,
  targetURL,
  scrollToTop = false
) {
  $targetElement.addClass("loading")

  if (scrollToTop) {
    $("html, body").animate(
      { scrollTop: $(".js-product-tabs").offset().top },
      500
    )
  }

  $.ajax({
    method: "GET",
    url: targetURL,
    dataType: "json",
    success: function (response) {
      // replace target element with returned view partial
      let viewPartial = response["html"]
      let $viewPartial = $(viewPartial)
      $targetElement.replaceWith(viewPartial)

      if ($viewPartial.is("#js-tab-content-ratings")) {
        if ($viewPartial.find(".js-new-product-rating-form").length) {
          initializeBarRating(".js-bar-rating")
          initializeRatingsFormHandler()
        }

        if ($viewPartial.find(".js-pagyContainer").length) {
          initializeRatingsPaginationHandler()
        }
      }

      if ($viewPartial.is("#js-tab-content-assets")) {
        initializeAssetsTabHandlers()
      }
    },
    error: function (xhr, status, error) {
      $targetElement
        .removeClass("loading")
        .html('<p class="text-danger">Failed to fetch and load section.</p>')
      displayFlashMessage("danger", error)
    },
  })
}
